import type { ApiConfig } from '../';
import { Api } from '../';

export function createApi<TModules = any>(options: ApiConfig<TModules>): Api<TModules> {
  return new Api(options.config, options.modules);
}
